import { TReduxActions } from '../../types/redux';
import { ENearbyHousesActionTypes } from '../../actions/nearbyHousesInfo/actions';
import { INearbyHousesInfoState } from '../../types/redux/nearbyHousesInfo';

export const initialState: INearbyHousesInfoState = {
  isFetching: false,
  isError: false,
  housesInfo: [],
};

export const nearbyHouseInfoReducer = (state = initialState, action: TReduxActions) => {
  switch (action.type) {
    case ENearbyHousesActionTypes.Request:
      return { ...state, housesInfo: [], isError: false, isFetching: true };
    case ENearbyHousesActionTypes.Success:
      return { ...state, housesInfo: action.payload.housesInfo, isError: false, isFetching: false };
    case ENearbyHousesActionTypes.Failure:
      return { ...state, housesInfo: [], isError: true, isFetching: false };
    default:
      return state;
  }
};
